import './base/';
import './utilities/is-touch';
import './utilities/responsive-images';
import './cart/cart';
import './cart/cart-utils';
import './sliders/product-slider';
import './sliders/announcements-slider';
import './sliders/featured-collection-slider';
import './sliders/testimonials-slider';
import './product/ajax-actions';
import './product/quantity';
import './product/form-variant-handler';
import './modules/mobile-nav-handler';
import './modules/tabs';
import './modules/recommendations';
import './modules/accordions';
import './modules/smooth-scroll';
import './polyfills/object-fit';

const $win = $(window);
const $doc = $(document);

// Your code goes here...
// jQuery.ready is no longer needed
